import React from 'react';
import getConfig from 'next/config';

const {
	publicRuntimeConfig: { basePath }
} = getConfig();

const Fonts = () => (
	<style jsx global>{`
		// Roboto Italic
		@font-face {
			font-weight: 400;
			font-family: 'Roboto';
			font-style: italic;
			src: url('${basePath}/fonts/Roboto/Roboto-Italic.eot');
			src:
				local('Roboto Italic'),
				local('Roboto-Italic'),
				url('${basePath}/fonts/Roboto/Roboto-Italic.eot?#iefix') format('embedded-opentype'),
				url('${basePath}/fonts/Roboto/Roboto-Italic.woff') format('woff'),
				url('${basePath}/fonts/Roboto/Roboto-Italic.ttf') format('truetype');
			font-display: swap;
		}
		
		// Roboto Bold
		@font-face {
			font-weight: 700;
			font-family: 'Roboto';
			font-style: normal;
			src: url('${basePath}/fonts/Roboto/Roboto-Bold.eot');
			src:
				local('Roboto Bold'),
				local('Roboto-Bold'),
				url('${basePath}/fonts/Roboto/Roboto-Bold.eot?#iefix') format('embedded-opentype'),
				url('${basePath}/fonts/Roboto/Roboto-Bold.woff') format('woff'),
				url('${basePath}/fonts/Roboto/Roboto-Bold.ttf') format('truetype');
			font-display: swap;
		}
		
		// Roboto
		@font-face {
			font-weight: normal;
			font-family: 'Roboto';
			font-style: normal;
			src: url('${basePath}/fonts/Roboto/Roboto-Regular.eot');
			src:
				local('Roboto'),
				local('Roboto-Regular'),
				url('${basePath}/fonts/Roboto/Roboto-Regular.eot?#iefix') format('embedded-opentype'),
				url('${basePath}/fonts/Roboto/Roboto-Regular.woff') format('woff'),
				url('${basePath}/fonts/Roboto/Roboto-Regular.ttf') format('truetype');
			font-display: swap;
		}
		
		// Roboto Light
		@font-face {
			font-weight: 300;
			font-family: 'Roboto';
			font-style: normal;
			src: url('${basePath}/fonts/Roboto/Roboto-Light.eot');
			src:
				local('Roboto Light'),
				local('Roboto-Light'),
				url('${basePath}/fonts/Roboto/Roboto-Light.eot?#iefix') format('embedded-opentype'),
				url('${basePath}/fonts/Roboto/Roboto-Light.woff') format('woff'),
				url('${basePath}/fonts/Roboto/Roboto-Light.ttf') format('truetype');
			font-display: swap;
		}
		
		// Roboto Medium
		@font-face {
			font-weight: 500;
			font-family: 'Roboto';
			font-style: normal;
			src: url('${basePath}/fonts/Roboto/Roboto-Medium.eot');
			src:
				local('Roboto Medium'),
				local('Roboto-Medium'),
				url('${basePath}/fonts/Roboto/Roboto-Medium.eot?#iefix') format('embedded-opentype'),
				url('${basePath}/fonts/Roboto/Roboto-Medium.woff') format('woff'),
				url('${basePath}/fonts/Roboto/Roboto-Medium.ttf') format('truetype');
			font-display: swap;
		}
		
		// Roboto Medium Italic
		@font-face {
			font-weight: 500;
			font-family: 'Roboto';
			font-style: italic;
			src: url('${basePath}/fonts/Roboto/Roboto-MediumItalic.eot');
			src:
				local('Roboto Medium Italic'),
				local('Roboto-MediumItalic'),
				url('${basePath}/fonts/Roboto/Roboto-MediumItalic.eot?#iefix') format('embedded-opentype'),
				url('${basePath}/fonts/Roboto/Roboto-MediumItalic.woff') format('woff'),
				url('${basePath}/fonts/Roboto/Roboto-MediumItalic.ttf') format('truetype');
			font-display: swap;
		}

		@font-face {
			font-weight: 400;
			font-family: 'PT Sans';
			font-style: normal;
			src:
				local('PT Sans'),
				local('PTSans-Regular'),
				url('${basePath}/fonts/PTSans/PTSansRegular.woff') format('woff');
			font-display: swap;
		}

		@font-face {
			font-weight: 400;
			font-family: 'PT Sans';
			font-style: italic;
		  	src:
				local('PT Sans Italic'),
				local('PTSans-Italic'),
				url('${basePath}/fonts/PTSans/PTSansItalic.woff') format('woff');
			font-display: swap;
		}

		@font-face {
			font-weight: 700;
			font-family: 'PT Sans';
			font-style: normal;
			src:
				local('PT Sans Bold'),
				local('PTSans-Bold'),
				url('${basePath}/fonts/PTSans/PTSansBold.woff') format('woff');
			font-display: swap;
		}
	`}</style>
);

export default Fonts;
